<template>
      <!-- <b-modal v-model="signUpModal"> -->
    <b-modal size='md' v-model="logInModal" hide-footer>
      <div slot="modal-header">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid meet" viewBox="0 350 500 250" height="50"><defs><path d="M150 448.33L150 598.33L0 598.33L0 348.33L50 348.33L50 448.33L150 448.33ZM275 498.33L275 598.33L225 598.33L225 498.33L175 498.33L175 448.33L325 448.33L325 498.33L275 498.33ZM500 498.33L400 498.33L400 598.33L350 598.33L350 448.33L500 448.33L500 498.33ZM50 548.33L100 548.33L100 498.33L50 498.33L50 548.33Z" id="logo"></path></defs>
        <g><use xlink:href="#logo" class="logosvg"></use></g></svg>
      </div>
      <b-form-input id="email" placeholder="Enter Email" :state="emailValid" v-model="email" type="email"></b-form-input>
      <br>
      <b-form-input id="password" placeholder="Enter Password" :state="checkPassword" v-model="password" type="password"></b-form-input>
      <br>  
      {{errorText}}   
      <div class="text-center">
        <b-btn :disabled="!formValid" class="mt-3" variant="outline-warning" size="lg" @click="emailSignIn">Log In</b-btn>
        <b-btn class="mt-3" variant="outline-danger" size="lg" @click="$emit('close')">Cancel</b-btn>
        <br>    
            By continuing you Accept our <router-link to="terms" target="_blank">Terms of use </router-link>
      </div>
      <hr> 
        <div class="text-center"> 
          <b-btn @click="googleSignIn"><font-awesome-icon  class="socialicon" :icon="['fab', 'google']" size="1x"/>  Continue with Google</b-btn>
          <!-- <b-btn @click="fbookSignIn"><font-awesome-icon  class="socialicon" :icon="['fab', 'facebook-f']" size="1x"/>   Continue with Facebook</b-btn> -->
        </div>
    </b-modal>
</template>

<script>
import firebase from 'firebase'
export default {
  name: 'SignIn',
  props: { logInModal: false },
  data () {
    return {
      email: '',
      password: '',
      confirmPassword: '',
      user: undefined,
      errorText: ''
    }
  },
  mounted () {},
  computed: {
    checkPassword () {
      if (this.password.length > 5) {
        return true
      } else if (this.password.length === 0) {
        return null
      } else {
        return false
      }
    },
    emailValid () {
      if (this.email) {
        var re = /\S+@\S+\.\S+/ // may need to dig a bit deeper into correct RE for this
        return re.test(this.email)
      } else {
        return null
      }
    },
    formValid () {
      return this.emailValid && this.checkPassword
    }
  },
  methods: {
    googleSignIn () {
      this.hideModal()
      const provider = new firebase.auth.GoogleAuthProvider()
      firebase.auth().signInWithPopup(provider).then((result) => {
        this.$parent.user = result.user
        this.$parent.status = true
      })
      .catch(error => console.log(error))
    },
    emailSignIn () {
      // this.hideModal()
      firebase.auth().signInWithEmailAndPassword(this.email, this.password)
        .then(
          user => {
            this.hideModal()
            console.log('setLoading')
            console.log('Created User', user)
          }
        )
        .catch(
          error => {
            console.log(error.message)
            this.errorText = error.message
          }
        )
    },
    hideModal () {
      this.$emit('close')
    },
    showModal () {
      this.$refs.signUpModalRef.show()
    }
  }
}
</script>

<style scoped>
#logo {
  fill:rgba(255, 192, 7, 1);
}
.title {
  font-family: 'lato', cursive;
  font-size: 7.0em;
  text-align: center;
  color: grey;
}
</style>



// WEBPACK FOOTER //
// src/components/User/login.vue